module.exports = __webpack_public_path__ + "media/images/ok-icon-6b47c9420bc591087379a0b2ba649518.png";